import makeStyles from '@material-ui/core/styles/makeStyles';

export const useNotificationsStyles = makeStyles((theme) => ({
  fab: {
    padding: 0,
    minWidth: '45px',
  },
  menu: {
    width: '500px',
    backgroundColor: theme.palette.grey[50],
    boxShadow: '#e0e2e3 0px 5px 10px',
  },
}));

export const useNotificationsIconStyles = makeStyles((theme) => ({
  icon: {
    width: '20px',
    height: '20px',
  },
}));

export const useNotificationsListStyles = makeStyles((theme) => ({
  btns: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 10px',
    borderBottom: '1px solid #cdcdcd',
  },
  btnLabel: {
    height: 24,
    lineHeight: '24px',
    fontSize: 14,
    textTransform: 'none',
    color: theme.palette.primary.light,
  },
  list: {
    maxHeight: '200px',
    overflow: 'auto',
  },
}));

export const useNotificationsListItemStyles = makeStyles((theme) => ({
  root: {
    padding: '6px 0',
    margin: '0 16px',
    borderBottom: '1px solid #dbdbdb',
    cursor: 'default',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  body: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  contentWrapper: {
    display: 'flex',
    paddingBottom: '5px',
  },
  content: {
    width: '100%',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    lineHeight: 'normal',
    fontSize: '14px',
  },
  info: { display: 'flex', justifyContent: 'space-between' },
  infoCreated: {
    color: theme.palette.primary.light,
    fontSize: '14px',
  },
  infoRead: {
    textTransform: 'capitalize',
    color: theme.palette.primary.light,
    fontSize: '14px',
    cursor: 'pointer',
    padding: '0 5px',
    borderRadius: 4,
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.08)',
    },
  },
  anchor: {
    textDecoration: 'underline',
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
  unreadContent: {
    fontWeight: 'bold',
    paddingRight: 5,
  },
  unreadIndicator: {
    width: 2,
    background: theme.palette.primary.main,
  },
}));
